import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ResponsiveSrcDirective} from './responsive-src.directive';
import {ResponsiveStateService} from './responsive-state.service';

@NgModule({
  imports: [
    CommonModule,
  ],
  declarations: [ResponsiveSrcDirective],
  providers: [ResponsiveStateService],
  exports: [ResponsiveSrcDirective],
})
export class ResponsiveImageModule {
}
